import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import helpers from '../util/helpers';
import * as constants from '../util/constants';

class GiftCardHotelsSkeleton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="row">
        {
          Array.from(Array(12).keys()).map((i) => {
            return (
              <div className="col-12 col-md-6 col-lg-4" key={i}>
                <a href="#" className="gift-shops-hotel-item d-block" target="_blank" rel="noopener noreferrer">
                  <div className="hotel-item-wrapper">
                    <div className="hotel-item-image-wrapper skeleton-shine" />
                    <div className="hotel-item-details balance-elements">
                      <h2 className="hotel-item-title skeleton-shine" />
                      <div className="hotel-item-description skeleton-shine" />
                      <div className="hotel-item-btn skeleton-shine"></div>
                    </div>
                  </div>
                </a>
              </div>
            );
          })
        }
      </div>
    );
  }
}

class AppGiftShopHotels extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      allGiftShopHotels: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.postID = '';
    const giftShopHotels = $('#gift-shop-hotels');
    if (giftShopHotels.length) {
      this.postID = giftShopHotels.data('post-id');
    }

    this.location = '';
    this.locationType = '';

    // Bind "this"
    this.loadGiftShopHotels = this.loadGiftShopHotels.bind(this);
    this.loadMoreGiftShopHotels = this.loadMoreGiftShopHotels.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  loadGiftShopHotels() {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source(); // Generate new source token
    }

    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_GIFT_SHOP_HOTELS,
      'location': this.location,
      'locationType': this.locationType,
      'postID': this.postID,
      'offset': 0,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const hotelsCount = response.data['hotels_count'];
          const hotels = [...response.data['hotels']];

          if (hotelsCount > 0) {
            this.setState({
              loading: false,
              allGiftShopHotels: [...hotels],
              loadMoreLoading: false,
              loadedAll: hotelsCount == hotels.length,
            });
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreGiftShopHotels() {
    const {
      allGiftShopHotels,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_GIFT_SHOP_HOTELS,
        'location': this.location,
        'offset': allGiftShopHotels.length,
      };

      // Send request
      axios.post(window.Rydges['ajaxUrl'], qs.stringify(data)).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const hotelsCount = response.data['hotels_count'];
            const hotels = [
              ...allGiftShopHotels,
              ...response.data['hotels'],
            ];

            if (hotelsCount > 0) {
              this.setState({
                loading: false,
                allGiftShopHotels: [...hotels],
                loadMoreLoading: false,
                loadedAll: hotelsCount == hotels.length,
              });
            } else {
              this.setState({
                loading: false,
                loadMoreLoading: false,
                loadedAll: true,
              });
            }
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  componentDidMount() {
    // Load gift shop hotels on first page load
    this.loadGiftShopHotels();

    $(document).on(constants.EVENT_SELECT_FILTER_CHANGED, (e, locationType, location) => {
      if (this.location !== location) {
        this.locationType = locationType;
        this.location = location;
        this.loadGiftShopHotels();
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.loading && !this.state.loading) ||
      (prevState.loadMoreLoading && !this.state.loadMoreLoading)
    ) {
      // Equal height for elements
      $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);
    }
  }

  render() {
    const {
      loading,
      allGiftShopHotels,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <React.Fragment>
        {
          !loading && allGiftShopHotels.length > 0 && (
            <div className="row">
              {
                allGiftShopHotels.map((hotel, i) => {
                  return (
                    <div className="col-12 col-md-6 col-lg-4" key={i}>
                      <a href={hotel['link']} className="gift-shops-hotel-item d-block" target="_blank" rel="noopener noreferrer">
                        <div className="hotel-item-wrapper">
                          <div className="hotel-item-image-wrapper">
                            <div className="hotel-item-image bg-center" style={{backgroundImage: `url(${hotel['image']})`}} />
                            {
                              hotel['ribbon_label'].length > 0 && (
                                <div className="hotel-item-ribbon">
                                  {hotel['ribbon_label']}
                                </div>
                              )
                            }
                          </div>
                          <div className="hotel-item-details">
                            <div className="balance-elements">
                              {
                                hotel['title'].length > 0 && (
                                  <h2 className="hotel-item-title">{hotel['title']}</h2>
                                )
                              }
                              {
                                hotel['description'] && (
                                  <div className="hotel-item-description">
                                    <p dangerouslySetInnerHTML={{__html: hotel['description']}} />
                                  </div>
                                )
                              }
                              {
                                hotel['number_of_vouchers'] > 0 && (
                                  <div className="hotel-item-vouchers">
                                    <img src={window.Rydges['assetsPath'] + 'images/icons/voucher.svg'} className="icon img-fluid" />
                                    {`${hotel['number_of_vouchers']} ${hotel['number_of_vouchers'] > 1 ? 'vouchers' : 'voucher'}`}
                                  </div>
                                )
                              }
                            </div>
                            {
                              hotel['link'].length > 0 && (
                                <button className="btn btn-red hotel-item-btn">Shop now</button>
                              )
                            }
                          </div>
                        </div>
                      </a>
                    </div>
                  );
                })
              }
            </div>
          )
        }
        {
          (loading || loadMoreLoading) && (
            <GiftCardHotelsSkeleton />
          )
        }
        {
          (loading || loadMoreLoading || allGiftShopHotels.length > 0) && (
            <div className="row justify-content-center">
              <button className="btn btn-red btn-lg btn-border-red btn-load-more mt-3" disabled={loading || loadMoreLoading || loadedAll } onClick={this.loadMoreGiftShopHotels}>
                {!loadedAll ? 'Load More' : 'That\'s All'}
              </button>
            </div>
          )
        }
      </React.Fragment>
    );
  }
}

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    // Gift shop hotels
    const giftShopHotels = $('#gift-shop-hotels');
    if (giftShopHotels.length) {
      ReactDOM.render(<AppGiftShopHotels />, giftShopHotels[0]);
    }

    const giftShopHotelsFilter = $('#gift-shop-hotel-locations-filter');
    if (giftShopHotelsFilter.length) {
      const handleFilterChanged = function() {
        let locationType = 'city';
        let selectedVal = giftShopHotelsFilter.val();
        let actualSelectedVal = selectedVal;
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['location'] = selectedVal;
        } else {
          delete params['location'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        if (selectedVal.indexOf('_region') > -1) {
          locationType = 'region';
          actualSelectedVal = selectedVal.substring(0, selectedVal.indexOf('_region'));
        } else if (selectedVal.indexOf('_country') > -1) {
          locationType = 'country';
          actualSelectedVal = selectedVal.substring(0, selectedVal.indexOf('_country'));
        }

        $(document).trigger(constants.EVENT_SELECT_FILTER_CHANGED, [locationType, actualSelectedVal]);
      };

      setTimeout(function() {
        handleFilterChanged();
      }, 1000);

      giftShopHotelsFilter.on('select2:select', function () {
        handleFilterChanged();
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalGiftCards.js